import { ModelSettings } from '../components/moleculas/inputform/types';

export const MAX_FILE_SIZE = 10000;

export const modelSettings: { [key: string]: ModelSettings } = {
  mii_lng: {
    allowedFileTypes: ['xls', 'xlsx'],
    isContentMenuEnabled: true,
    aboutContent:
      '<div style="position: relative"><h3>About the Model</h3><p>Coming soon</p></div>',
    readingContent:
      '<div style="width: 1200px; position: relative"><iframe  style=" top: 0; left: 0; right: 0; bottom: 0; position: relative; height: calc(100vh - 5px)" title="Research" width="99%" src="/research.pdf"></iframe></div>',
    contactContent:
      '<div style="position: relative"><h3>Contact Us</h3><p>For questions, please contact Arvind Ravikumar at <a href="mailto:arvind.ravikumar@austin.utexas.edu">arvind.ravikumar@austin.utexas.edu</a>. </p></div>' +
      '<p>For inquiries on collaborative projects with EEMDL, please contact <a href="mailto:eemdl@utexas.edu">eemdl@utexas.edu</a>.</p>',
    eemdlContent:
      '<div style="position: relative"><h3>About EEMDL</h3>' +
      '<p><img src="/assets/ceesa-logo.png" style="width:100px;" alt="" ></p>' +
      "<p>The Energy Emissions Modeling and Data Lab (EEMDL) is a multi-disciplinary research and education center that operates as a global data and analytics hub, focusing on improving greenhouse gas emissions accounting across energy supply chains. This initiative is a collaborative effort involving the University of Texas at Austin, Colorado State University, and the Colorado School of Mines. EEMDL's mission is to provide reliable, science-based, transparent, and measurement-based greenhouse gas emissions assessments of global oil and gas supply chains. The lab aims to achieve this through the development of community models and tools for greenhouse gas emissions assessments, the provision of publicly available timely, high-resolution emissions datasets, and the creation of educational and training materials to enable widespread use of EEMDL's models and data.</p><p>The lab is focused on addressing the challenge of interpreting measurements to develop supply chain emissions intensities or measurement-informed emissions inventories. To achieve this, EEMDL leverages recent advances in technologies such as aerial systems, satellites, and continuous emissions monitoring systems to gain unprecedented insight into global oil and gas methane emissions. By providing standardized ways to interpret greenhouse gas emissions measurement data, EEMDL aims to support improved greenhouse gas emissions accounting across energy supply chains.</p>" +
      '<h3>About CEESA</h3><p>CEESA provides data-driven, science-based research to inform global policy and support real-world emissions reductions across the energy sector. Our mission is to provide rigorous, measurement-informed insights that empower decision-makers to drive meaningful emissions reductions.</p></div>',
    sheets: [
      {
        name: 'Facility Summary',
        columns: [
          'Facility Name',
          'First Scan Date Time (UTC)',
          'Last Scan Date Time (UTC)',
          'Emission Sources Seen',
          'Total Facility Emission (SCFH)',
        ],
      },
      {
        name: 'Emission Location Summary',
        columns: [
          'Facility Name',
          'Emission Location',
          'First Scan Date Time (UTC)',
          'Last Scan Date Time (UTC)',
          ['Average Plume Height (ft)', 'Emitter Group Height (ft)'],
          'Avg Emission Rate (SCFH)',
          ['Persistence', 'Persistence Rate'],
          'Number Of Scans',
          'Latitude',
          'Longitude',
        ],
      },
      {
        name: 'Emission Location Extended',
        columns: [
          'Facility Name',
          'Emission Location',
          'Scan Date Time (UTC)',
          'Gas Detected',
          'Detection Id',
          'Emission Location Within Facility Polygon',
          'Emission Rate (SCFH)',
          'Emitter Height (ft)',
          'Max Concentration (ppm-m)',
          'Wind Speed (mph)',
          ['Persistence', 'Persistence Rate'],
          'Latitude',
          'Longitude',
        ],
      },
    ],
    title: 'Measurement Informed Inventory: LNG',
    fileField: 'file',
    isDownloadAllowed: true,
    description:
      '        This model is based on <a href="https://chemrxiv.org/engage/chemrxiv/article-details/66c67032a4e53c48762fb9e3">\n' +
      '          Multi-scale Measurements of Greenhouse Gas Emissions at U.S. Natural\n' +
      '          Gas Liquefaction Terminals\n' +
      '        </a>\n' +
      '        . The intention of this model is to enable operators of LNG supply chain\n' +
      '        components to better estimate their methane emissions based on survey\n' +
      '        data. The interface expects the Bridger survey template format. Please\n' +
      '        remove any rows that contain emission sources out of the LNG terminal\n' +
      '        site before uploading file.',
    paramsMapping: {
      param1: {
        name: 'turbine_exhaust',
        label: 'Turbine Exhaust',
        unit: 'SCFH',
        description: 'Turbine exhaust emissions (annualized), SCFH',
      },
      param2: {
        name: 'thermal_oxidizer',
        label: 'Thermal oxidizer',
        unit: 'SCFH',
        description: 'Thermal oxidizers emission (annualized), SCFH',
      },
      param3: {
        name: 'small_fugitives',
        label: 'Small Fugitives',
        unit: 'SCFH',
        description: 'Small fugitive emissions (annualized), SCFH',
      },
      param4: {
        name: 'aircraft_type',
        label: 'Aircraft Type',
        description: '',
        values: [
          { label: 'Fixed Wing', value: 'fixed_wing' },
          { label: 'Rotary Wing', value: 'rotary_wing' },
        ],
      },
      param5: {
        name: 'LNG_production_rate',
        label: 'LNG Production Rate',
        unit: 'MMcf/year',
        description: 'The production rate of LNG in gaseous phase in MMcf/year',
      },
      param6: {
        name: 'methane_mol_con',
        label: 'Methane molar concentration',
        unit: '%',
        description:
          'The molar concentration of methane in the produced LNG (in % - ex: 95)',
      },
    },
    // fileTemplateToDownload: 'MIIModel_Input_template.xlsx',
    fileTemplateToDownload:
      'https://flexplanfuncmodelspa11d.blob.core.windows.net/m1template/MII_Liquefaction_template.xlsx?sp=r&st=2025-03-24T14:19:12Z&se=2026-03-24T22:19:12Z&spr=https&sv=2024-11-04&sr=b&sig=4UUIddiA%2FIz9tUxiSkqBQ7K%2FGIcoukDOJEvsQUephjo%3D',
    submitButtonLabel: 'Run MII Model',
    rowToValidate: 4,
    apiUrl: {
      DEV: 'https://flexplanfuncmodels.azurewebsites.net/api/liquefaction', //dev env azure
      // DEV: 'http://localhost:3000/FlexTest',   //node
      // DEV: 'http://localhost:7071/api/liquefaction', // local pyt
      QA: 'https://flexplanfuncmodelsqa.azurewebsites.net/api/liquefaction',
      PROD: 'https://flexplanfuncmodelsprod.azurewebsites.net/api/liquefaction',
    },
  },
  mii_upstream: {
    allowedFileTypes: ['xls', 'xlsx'],
    isContentMenuEnabled: true,
    aboutContent:
      '<div style="position: relative"><h3>About the Model</h3><p>Coming soon</p></div>',
    readingContent:
      '<div style="width: 1200px; position: relative"><iframe  style=" top: 0; left: 0; right: 0; bottom: 0; position: relative; height: calc(100vh - 5px)" title="Research" width="99%" src="/research.pdf"></iframe></div>',
    contactContent:
      '<h3>Contact Us</h3><p>For questions, please contact Arvind Ravikumar at <a href="mailto:arvind.ravikumar@austin.utexas.edu">arvind.ravikumar@austin.utexas.edu</a>. </p>' +
      '<p>For inquiries on collaborative projects with EEMDL, please contact <a href="mailto:eemdl@utexas.edu">eemdl@utexas.edu</a>.</p>',
    eemdlContent:
      '<div style="position: relative"><p><img src="/assets/ceesa-logo.png" alt="" style="width: 300px; " ></p>' +
      '<h3>About EEMDL</h3>' +
      "<p>The Energy Emissions Modeling and Data Lab (EEMDL) is a multi-disciplinary research and education center that operates as a global data and analytics hub, focusing on improving greenhouse gas emissions accounting across energy supply chains. This initiative is a collaborative effort involving the University of Texas at Austin, Colorado State University, and the Colorado School of Mines. EEMDL's mission is to provide reliable, science-based, transparent, and measurement-based greenhouse gas emissions assessments of global oil and gas supply chains. The lab aims to achieve this through the development of community models and tools for greenhouse gas emissions assessments, the provision of publicly available timely, high-resolution emissions datasets, and the creation of educational and training materials to enable widespread use of EEMDL's models and data.</p><p>The lab is focused on addressing the challenge of interpreting measurements to develop supply chain emissions intensities or measurement-informed emissions inventories. To achieve this, EEMDL leverages recent advances in technologies such as aerial systems, satellites, and continuous emissions monitoring systems to gain unprecedented insight into global oil and gas methane emissions. By providing standardized ways to interpret greenhouse gas emissions measurement data, EEMDL aims to support improved greenhouse gas emissions accounting across energy supply chains.</p>" +
      '<h3>About CEESA</h3><p>CEESA provides data-driven, science-based research to inform global policy and support real-world emissions reductions across the energy sector. Our mission is to provide rigorous, measurement-informed insights that empower decision-makers to drive meaningful emissions reductions.</p></div>',
    sheets: [
      {
        name: ['Anonymized Q3 Emission Extended', 'Emission Location Extended'],
        columns: [
          'Region',
          'Facility Name',
          'Facility Type Ami',
          'Sponsored',
          'Oil And Gas',
          'Emission Location Id',
          'Detection Id',
          'Flight',
          'Equipment Id',
          'Equipment Type',
          'Gas Detected',
          'Emission Rate (SCFH)',
          'Persistence',
          'Detection Condition',
          'Emitter In Buffer',
        ],
      },
      {
        name: ['Anonymized Q3 Equip Aggregate', 'Equipment Aggregate'],
        columns: [
          'Region',
          'Facility Name',
          'Equipment Type',
          'Equipment Id',
          'Scan Count',
          'Persistence',
          'Avg Emission Rate (SCFH)',
        ],
      },
      {
        name: ['Anonymized Q3 Facility Summary', 'Facility Summary'],
        columns: [
          'Region',
          'Facility Name',
          'Facility Type Ami',
          'Sponsored',
          'Oil And Gas',
          'Emission Location Count',
          'Gas Detected',
        ],
      },
      // {
      //   name: 'AMI Op Q3 Emission Extended',
      //   columns: [
      //     'Region',
      //     'AMI Operator',
      //     'Ami Facility Type',
      //     'Site Id',
      //     'Emission Location Id',
      //     'Detection Id',
      //     'Equipment Id',
      //     'Equipment Type',
      //     'Scan Date Time (UTC)',
      //     'Gas Detected',
      //     'Emission Rate (SCFH)',
      //     'Persistence',
      //   ],
      // },
      // {
      //   name: 'AMI Op Q3 Equip Aggregate',
      //   columns: [
      //     'Region',
      //     'AMI Operator',
      //     'Ami Facility Type',
      //     'Site Id',
      //     'Equipment Type',
      //     'Equipment Id',
      //     'Scan Count',
      //     'First Scan (UTC)',
      //     'Last Scan (UTC)',
      //     'Persistence',
      //     'Avg Emission Rate (SCFH)',
      //   ],
      // },
      // {
      //   name: 'AMI Op Q3 Facility Summary',
      //   columns: [
      //     'Region',
      //     'AMI Operator',
      //     'Ami Facility Type',
      //     'Site Id',
      //     'First Scan Date Time (UTC)',
      //     'Last Scan Date Time (UTC)',
      //     'Emission Location Count',
      //     'Gas Detected',
      //     'Intermittent Facility Emission (SCFH)',
      //     'Persistent Facility Emission (SCFH)',
      //     'Total Facility Emission (SCFH)',
      //   ],
      // },
      // {
      //   name: 'Pneumatic Controller EF',
      //   columns: [
      //     'Basin',
      //     'Pneumatic Controller Types',
      //     'Count Per Well',
      //     'Leaker EF (scf whole gas/hour/unit)',
      //   ],
      // },
      // {
      //   name: 'Pneumatic Pump EF',
      //   columns: ['Basin', 'Count Per Well', 'EF (scf whole gas/hour/unit)'],
      // },
      // {
      //   name: 'Gas Composition',
      //   columns: ['Region', 'Methane molar fraction'],
      // },
      // {
      //   name: 'Component AF',
      //   columns: [
      //     'Major equipment',
      //     'Valve',
      //     'Flange',
      //     'Connector',
      //     'OEL',
      //     'Pressure relief valve',
      //   ],
      // },
      // {
      //   name: 'Component EF',
      //   columns: ['Component', 'Leaker EF (scfh methane)'],
      // },
      // {
      //   name: 'AMI Q3 One Time Events',
      //   columns: [
      //     'Region',
      //     'AMI Operator',
      //     'Facility Name',
      //     'One Time Event Total (kg)',
      //   ],
      // },
      // {
      //   name: 'Root Cause Analysis',
      //   columns: [
      //     'Region',
      //     'Operator',
      //     'Equipment Type',
      //     'Equipment ID',
      //     'Emission Location ID',
      //     'Duration (Days)',
      //   ],
      // },
    ],
    title: 'Measurement Informed Inventory: Upstream Basin',
    fileField: 'file',
    isDownloadAllowed: true,
    fileTemplateToDownload: 'MII_BASIN_INPUT_TEMPLATE.xlsx',
    submitButtonLabel: 'Run MII Model',
    rowToValidate: 0,
    apiUrl: {
      DEV: 'https://miifunc.azurewebsites.net/api/basin',
      QA: 'https://miifunc.azurewebsites.net/api/basin',
      PROD: 'https://mii-prod.azurewebsites.net/api/basin',
    },
    paramsMapping: undefined,
  },
  meet_pneumatics: {
    allowedFileTypes: ['xls', 'xlsx'],
    isContentMenuEnabled: true,
    aboutContent:
      '<div style="position: relative"><h3>About the Model</h3><p>Coming soon</p></div>',
    readingContent:
      '<div style="width: 1200px; position: relative"><iframe  style=" top: 0; left: 0; right: 0; bottom: 0; position: relative; height: calc(100vh - 5px)" title="Research" width="99%" src="/research.pdf"></iframe></div>',
    contactContent:
      '<h3>Contact Us</h3><p>For questions, please contact Arvind Ravikumar at <a href="mailto:arvind.ravikumar@austin.utexas.edu">arvind.ravikumar@austin.utexas.edu</a>. </p>' +
      '<p>For inquiries on collaborative projects with EEMDL, please contact <a href="mailto:eemdl@utexas.edu">eemdl@utexas.edu</a>.</p>',
    eemdlContent:
      '<div style="position: relative"><p><img src="/assets/ceesa-logo.png" alt="" style="width: 300px; " ></p>' +
      '<h3>About EEMDL</h3>' +
      "<p>The Energy Emissions Modeling and Data Lab (EEMDL) is a multi-disciplinary research and education center that operates as a global data and analytics hub, focusing on improving greenhouse gas emissions accounting across energy supply chains. This initiative is a collaborative effort involving the University of Texas at Austin, Colorado State University, and the Colorado School of Mines. EEMDL's mission is to provide reliable, science-based, transparent, and measurement-based greenhouse gas emissions assessments of global oil and gas supply chains. The lab aims to achieve this through the development of community models and tools for greenhouse gas emissions assessments, the provision of publicly available timely, high-resolution emissions datasets, and the creation of educational and training materials to enable widespread use of EEMDL's models and data.</p><p>The lab is focused on addressing the challenge of interpreting measurements to develop supply chain emissions intensities or measurement-informed emissions inventories. To achieve this, EEMDL leverages recent advances in technologies such as aerial systems, satellites, and continuous emissions monitoring systems to gain unprecedented insight into global oil and gas methane emissions. By providing standardized ways to interpret greenhouse gas emissions measurement data, EEMDL aims to support improved greenhouse gas emissions accounting across energy supply chains.</p>" +
      '<h3>About CEESA</h3><p>CEESA provides data-driven, science-based research to inform global policy and support real-world emissions reductions across the energy sector. Our mission is to provide rigorous, measurement-informed insights that empower decision-makers to drive meaningful emissions reductions.</p></div>',

    sheets: [],
    title: 'Methane Emissions Estimation Tool (MEET): Pneumatic Controllers',
    fileField: 'file',
    isDownloadAllowed: false,
    description:
      'Methane Emissions Estimation Tool (MEET): Pneumatic Controllers',
    paramsMapping: undefined,
    rowToValidate: 1,
    apiUrl: {
      DEV: 'https://meet-dev.azurewebsites.net/api/pneumatic', //dev env azure
      // DEV: 'http://localhost:3000/FlexTest',   //node
      // DEV: 'http://localhost:7071/api/pneumatics', // local pyt
      QA: 'https://meet-dev.azurewebsites.net/api/pneumatic',
      PROD: 'https://meet-prod.azurewebsites.net/api/pneumatic',
    },
    submitButtonLabel: 'Run MEET Model',
  },
};
